import { BaseModel } from '../base.model';
import { SmartSavers } from '..';

class ProblemRecentPerformanceModel extends BaseModel {

  id: number;
  problemId: number;
  answer: string;
  isCorrect: number;
  time: number;
  isPersistence: number;
  smartSaverUsed: SmartSavers;
  reviewFlagged: number;
  problemTitle: string = undefined;
  topicDisplayName: string = undefined;

}

export { ProblemRecentPerformanceModel };
